<template>
  <div class="pulse-strength-indicator">
    <div
      v-for="strength in strengths"
      :key="strength"
      class="bar"
      :class="{ filled: value >= strength }"
      :style="{ height: `${strength * 5}px` }"
    />
  </div>
</template>

<script>
import range from 'lodash/range';

export default {
  name: 'pulse-strength-indicator',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      strengths: range(5).map((v) => v + 1),
    };
  },
};
</script>

<style scoped>
.pulse-strength-indicator {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.bar {
  width: 5px;
  margin-right: 3px;
}
.bar.filled {
  background-color: #3498db;
}
.bar {
  border: solid 1px #3498db;
}
</style>